'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _baseUtils = require('../utils/baseUtils');

var _windowWrapper = require('../sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

var _appSettings = require('./appSettings');

var _appSettings2 = _interopRequireDefault(_appSettings);

var _experimentsWrapper = require('../sdk/experimentsWrapper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GallerySettings = function () {
  function GallerySettings() {
    var _this = this;

    (0, _classCallCheck3.default)(this, GallerySettings);

    try {
      this.protocol = _windowWrapper2.default.location.protocol;
      this.galleryId = _windowWrapper2.default.galleryId;
      this.instance = _windowWrapper2.default.instance;
    } catch (e) {
      this.protocol = 'http:';
      this.galleryId = '';
      this.instance = '';
    }
    this.baseUrl = this.protocol + '//progallery.wix.com/_api/pro-gallery-editor-webapp/v1/gallery/';
    this.getGallerySettingsApi = function () {
      return '' + _this.baseUrl + _this.galleryId + '?instance=' + _this.instance + '&isStore=' + _baseUtils.baseUtils.isStoreGallery();
    };
    this.appSettings = new _appSettings2.default();
  }

  (0, _createClass3.default)(GallerySettings, [{
    key: 'get',
    value: function get(key) {
      return _axios2.default.get(this.getGallerySettingsApi(), { withCredentials: true, xsrfCookieName: null }).then(function (_ref) {
        var data = _ref.data;

        return key ? data.settings[key] : data.settings;
      });
    }
  }, {
    key: 'set',
    value: function set(key, value) {
      var _this2 = this;

      return this.get().then(function (data) {
        data = data || {};
        var settings = (0, _assign2.default)(data, (0, _defineProperty3.default)({}, key, value));
        return _axios2.default.put(_this2.getGallerySettingsApi(), { settings: settings }, { withCredentials: true, xsrfCookieName: null }).then(function () {
          return _baseUtils.baseUtils.setExternalId();
        });
      });
    }
  }, {
    key: 'setAppSettings',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(key, value) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_experimentsWrapper.experimentsWrapper.getExperimentBoolean('specs.pro-gallery.appSettings')) {
                  _context.next = 11;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return this.appSettings.set(key, value);

              case 4:
                _baseUtils.baseUtils.setExternalId();
                return _context.abrupt('return', _promise2.default.resolve());

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.error('Failed to set ' + key + ' in appSettings: ' + _context.t0);

              case 11:
                this.set(key, value);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 8]]);
      }));

      function setAppSettings(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return setAppSettings;
    }()
  }]);
  return GallerySettings;
}();

var gallerySettings = new GallerySettings();
exports.default = gallerySettings;